module.exports = __webpack_public_path__ + "img/banner.ebe7c3e4.png";